// extracted by mini-css-extract-plugin
export var bar = "ProgressBar-module__bar___ztLHy";
export var barFill = "ProgressBar-module__barFill___i8EPy";
export var footnote = "ProgressBar-module__footnote___lKu04";
export var percentageText = "ProgressBar-module__percentageText___Pc2eF";
export var title = "ProgressBar-module__title___Em6wX";